import { GridRowId } from '@mui/x-data-grid-pro';
import { ComponentProps, useState } from 'react';
import StyledDataGrid from '../DataGrid.styled';

export const useExpandOnRowClick = () => {
  const [expandedRowIds, setExpandedRowIds] = useState<GridRowId[]>([]);

  const onRowClick: ComponentProps<typeof StyledDataGrid>['onRowClick'] = params => {
    const isRowExpanded = expandedRowIds.includes(params.id);

    setExpandedRowIds(isRowExpanded ? expandedRowIds.filter(id => id !== params.id) : [...expandedRowIds, params.id]);
  };

  const onDetailPanelExpandedRowIdsChange: ComponentProps<
    typeof StyledDataGrid
  >['onDetailPanelExpandedRowIdsChange'] = ids => {
    setExpandedRowIds(ids);
  };

  const expandProps: Pick<
    ComponentProps<typeof StyledDataGrid>,
    'detailPanelExpandedRowIds' | 'onRowClick' | 'onDetailPanelExpandedRowIdsChange'
  > = {
    detailPanelExpandedRowIds: expandedRowIds,
    onRowClick,
    onDetailPanelExpandedRowIdsChange
  };

  return expandProps;
};
